import { useCallback, useEffect, useState } from 'react';
import CookieIcon from '@mui/icons-material/Cookie';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var COOKIE_CONSENT = 'CookieConsent';
export default function CookieOverlay() {
  var _document;

  var _useState = useState(false),
      shouldShow = _useState[0],
      setShouldShow = _useState[1];

  var hasCookie = document && ((_document = document) === null || _document === void 0 ? void 0 : _document.cookie.includes(COOKIE_CONSENT));
  useEffect(function () {
    if (hasCookie) {
      return setShouldShow(false);
    }

    setShouldShow(true);
  }, [hasCookie]);
  var handleCookie = useCallback(function (_ref) {
    var acceptance = _ref.acceptance;
    document.cookie = "".concat(COOKIE_CONSENT, "=").concat(acceptance, "; path=/");
    setShouldShow(false);
  }, []);
  return shouldShow ? /*#__PURE__*/_jsxs("div", {
    className: " absolute bottom-0 left-0 h-[470px] w-full rounded-t-2xl bg-[#F5F5F5] p-6",
    children: [/*#__PURE__*/_jsxs("h4", {
      className: "mb-4 flex items-center text-xl font-black",
      children: [/*#__PURE__*/_jsx("div", {
        className: "mr-4 flex items-center justify-center rounded-full border-[1px] border-[#D6D6D6] p-2",
        children: /*#__PURE__*/_jsx(CookieIcon, {
          className: "text-brand-primary"
        })
      }), "We value your privacy"]
    }), /*#__PURE__*/_jsxs("p", {
      className: "mb-4",
      children: ["This website stores cookies on your computer. These cookies are used to improve your website experience and provide more personalized services to you, both on this website and through other media. To find out more about the cookies we use, see our", ' ', /*#__PURE__*/_jsx("a", {
        href: "https://www.jove.co/legal/privacy-policy",
        target: "_blank",
        className: "text-brand-secondary font-bold underline",
        children: "Privacy Policy"
      }), "."]
    }), /*#__PURE__*/_jsx("p", {
      className: "mb-4",
      children: "We won't track your information when you visit our site. But in order to comply with your preferences, we'll have to use just one tiny cookie so that you're not asked to make this choice again."
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex justify-between gap-4",
      children: [/*#__PURE__*/_jsx("div", {
        onClick: function onClick() {
          return handleCookie({
            acceptance: false
          });
        },
        role: "button",
        className: "w-full rounded-full border-[1px] border-[#D6D6D6] bg-white p-4 text-center font-bold text-black hover:bg-black hover:text-white",
        children: "Decline"
      }), /*#__PURE__*/_jsx("div", {
        onClick: function onClick() {
          return handleCookie({
            acceptance: true
          });
        },
        role: "button",
        className: "bg-brand-primary w-full rounded-full border-[1px] border-[brand-primary] p-4 text-center font-bold text-white hover:bg-black hover:text-white",
        children: "Accept"
      })]
    })]
  }) : null;
}